// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tyrogue: PokeData = {
  "id": 236,
  "name": "tyrogue",
  "height": 7,
  "weight": 210,
  "base_experience": 42,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "tackle",
    "focus-energy",
    "foresight",
    "fake-out",
    "helping-hand"
  ],
  "moves": [
    "tackle",
    "vacuum-wave",
    "rolling-kick",
    "superpower",
    "bulk-up",
    "double-kick",
    "meteor-assault",
    "coaching",
    "close-combat",
    "drain-punch",
    "karate-chop",
    "jump-kick"
  ],
  "evolution_chain": {
    "id": 47,
    "item": null,
    "species": [
      {
        "name": "tyrogue",
        "order": 115,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "hitmonlee",
        "order": 116,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": 1,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hitmonchan",
        "order": 117,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": -1,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hitmontop",
        "order": 118,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": 0,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 35,
    "speed": 35,
    "ability_power": 35
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
